// extracted by mini-css-extract-plugin
export default {"btn_dell_options":"RowAction_btn_dell_options__-Zoop"};